import Vue from "vue";
import VueRouter from "vue-router";
import firebase from "@/firebase/firebaseInit";
const auth = firebase.auth;
// import firebase from "firebase/compat/app";
// import store from '@/store/store.js';
// import C from "@/constants"

Vue.use(VueRouter);

const routes = [
  {
    name: 'Login',
    path: '/login',
    component: () => import('@/views/Login.vue'),
  },
  {
    name: 'Register',
    path: '/register',
    component: () => import('@/views/Register.vue'),
  },
  {
    path: "/",
    component: () => import("@/views/Layout.vue"),
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        name: "Dashboard",
        path: "",
        component: () => import("@/components/inventory/Dashboard.vue"),
      },
      {
        name: "Test",
        path: "/test",
        component: () => import("@/components/inventory/ClickupTask.vue"),
      },
      {
        name: "InventoryList",
        path: "/inventory/list",
        component: () => import("@/components/inventory/InventoryList.vue"),
      },
      {
        name: "ManufacturingList",
        path: "/manufacturing/list/:status?",
        component: () => import("@/components/inventory/ManufacturingList.vue"),
      },
      {
        name: "PurchasingList",
        path: "/purchasing/list",
        component: () => import("@/components/inventory/PurchasingList.vue"),
      },
      {
        name: "MovementsList",
        path: "/catalog/:display?",
        component: () => import("@/components/inventory/MovementsList.vue"),
      },
      {
        name: "MovementComponentsList",
        path: "/movements/components/:mode/:id",
        component: () => import("@/components/inventory/MovementComponentsList.vue"),
      },
      {
        name: "ToolsList",
        path: "/tools/list",
        component: () => import("@/components/inventory/ToolsList.vue"),
      },
      {
        name: "BasesList",
        path: "/bases/list",
        component: () => import("@/components/inventory/BasesList.vue"),
      },
      {
        name: "ImportCsv",
        path: "/import",
        component: () => import("@/components/inventory/utilities/ImportCsv.vue"),
      },
      {
        name: "Export",
        path: "/export",
        component: () => import("@/components/inventory/utilities/Export.vue"),
      },
      {
        name: "Costs",
        path: "/costs",
        component: () => import("@/components/inventory/Costs.vue"),
      },
      {
        name: "UsersList",
        path: "/users/list",
        component: () => import("@/components/inventory/UsersList.vue"),
      },
      {
        name: "TestFilters",
        path: "/filters",
        component: () => import("@/components/inventory/TestFilters.vue"),
      },
      {
        name: "Scanner",
        path: "/scanner",
        component: () => import("@/components/inventory/utilities/Scanner.vue"),
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

// make sure only logged-in users have access to the content while onyl guests(+not signed-in users) see register & login
router.beforeEach((to, from, next) => {
  console.log("NEXT: ");
  console.log(to);
  console.log("FROM: ");
  console.log(from);

  const currentUser = auth.currentUser;
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

  // redirect to login if not signed in
  if(requiresAuth && !currentUser) next('Login');
  // skip login if user is already signed in
  else if (!requiresAuth && currentUser) next ('Dashboard');
  // continue navigation otherwise
  else next();
  next();
});

export default router;
